import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Link,
} from "@mui/material";
import { Phone, Google } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { postData } from "../../Webservice/Webservice";
import { toast } from "react-toastify";

function Signin() {
  const navigate = useNavigate();
  const [isPhoneLogin, setIsPhoneLogin] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    mobile: "",
    otp: "",
    type: "email",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error("Please fill in all required fields");
      return;
    }

    const payload = {
      email: formData.email,
      password: formData.password,
      type: "email",
    };

    try {
      const response = await postData("customer/login", payload);
      if (response && !response.error) {
        // Store tokens and user info
        if (response.token) {
          sessionStorage.setItem("token", response.token);
          sessionStorage.setItem("commonToken", response.token);
          sessionStorage.setItem("userType", "common");
          if (response.customer) {
            sessionStorage.setItem("user", JSON.stringify(response.customer));
          }
        }
        navigate("/");
      }
    } catch (error) {
      console.error("Signin error:", error);
    }
  };

  const handlePhoneSubmit = async () => {
    if (!formData.mobile) {
      toast.error("Please enter mobile number");
      return;
    }

    const payload = {
      mobile: formData.mobile,
      type: "mobile",
      customerType: "customer"
    };

    try {
      const response = await postData("customer/register", payload);
      if (response && !response.error) {
        toast.success("OTP sent successfully");
        setIsOtpSent(true);
      }
    } catch (error) {
      console.error("Phone login error:", error);
    }
  };

  const handleVerifyOtp = async () => {
    if (!formData.otp) {
      toast.error("Please enter OTP");
      return;
    }

    const payload = {
      mobile: formData.mobile,
      code: formData.otp
    };

    try {
      const response = await postData("customer/verify-mobile-otp", payload);
      if (response && !response.error) {
        // Store tokens and user info
        if (response.token) {
          sessionStorage.setItem("token", response.token);
          sessionStorage.setItem("commonToken", response.token);
          sessionStorage.setItem("userType", "common");
          if (response.customer) {
            sessionStorage.setItem("user", JSON.stringify(response.customer));
          }
        }
        toast.success("Login successful");
        navigate("/");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Left Section - Signin Form */}
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          maxWidth: 550,
        }}
      >
        <Box sx={{ maxWidth: 350, width: "100%", mx: "auto" }}>
          <Box
            component="img"
            src="/img/tvfml.png"
            alt="TVFM Logo"
            sx={{
              height: 45,
              width: "auto",
              mb: 2,
            }}
          />

          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", mb: 1, color: "#000" }}
          >
            Sign In
          </Typography>

          <Box component="form" noValidate onSubmit={handleSubmit}>

            {!isPhoneLogin ? (
              <>
                {/* Email */}
                <TextField
                  fullWidth
                  label="Email address"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  required
                />

                {/* Password */}
                <TextField
                  fullWidth
                  label="Password"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                  required
                />

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 3,
                    mb: 2,
                    py: 1.2,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: "1rem",
                    backgroundColor: "#000",
                    "&:hover": { backgroundColor: "#333" },
                  }}
                >
                  Sign In
                </Button>
              </>
            ) : (
              <>
                {!isOtpSent ? (
                  <>
                    {/* Mobile Number */}
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      variant="outlined"
                      margin="normal"
                      required
                    />

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handlePhoneSubmit}
                      sx={{
                        mt: 3,
                        mb: 2,
                        py: 1.2,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "1rem",
                        backgroundColor: "#000",
                        "&:hover": { backgroundColor: "#333" },
                      }}
                    >
                      Send OTP
                    </Button>
                  </>
                ) : (
                  <>
                    {/* OTP Input */}
                    <TextField
                      fullWidth
                      label="Enter 6-digit OTP"
                      name="otp"
                      value={formData.otp}
                      onChange={handleChange}
                      variant="outlined"
                      margin="normal"
                      required
                      inputProps={{ maxLength: 6 }}
                    />

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handleVerifyOtp}
                      sx={{
                        mt: 3,
                        mb: 2,
                        py: 1.2,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "1rem",
                        backgroundColor: "#000",
                        "&:hover": { backgroundColor: "#333" },
                      }}
                    >
                      Verify OTP
                    </Button>
                  </>
                )}
              </>
            )}

            {/* Divider with "or" text */}
            <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
              <Box sx={{ flex: 1, height: '1px', backgroundColor: '#e0e0e0' }} />
              <Typography variant="body2" sx={{ px: 2, color: '#666' }}>
                or
              </Typography>
              <Box sx={{ flex: 1, height: '1px', backgroundColor: '#e0e0e0' }} />
            </Box>

            {/* Phone/Email Toggle Button */}
            <Button
              fullWidth
              variant="outlined"
              startIcon={isPhoneLogin ? null : <Phone />}
              onClick={() => {
                setIsPhoneLogin(!isPhoneLogin);
                setIsOtpSent(false); // Reset OTP state when switching
              }}
              sx={{
                mb: 2,
                py: 1.2,
                borderRadius: "8px",
                textTransform: "none",
                fontSize: "1rem",
                borderColor: '#000',
                color: '#000',
                "&:hover": {
                  borderColor: '#333',
                  backgroundColor: 'rgba(0,0,0,0.04)'
                },
              }}
            >
              {isPhoneLogin ? "Sign in with Email" : "Sign in with Phone"}
            </Button>

            {/* Google Sign In Button */}
            <Button
              fullWidth
              variant="outlined"
              startIcon={<Google />}
              sx={{
                mb: 2,
                py: 1.2,
                borderRadius: "8px",
                textTransform: "none",
                fontSize: "1rem",
                borderColor: '#000',
                color: '#000',
                "&:hover": {
                  borderColor: '#333',
                  backgroundColor: 'rgba(0,0,0,0.04)'
                },
              }}
            >
              Sign in with Google
            </Button>
          </Box>

          <Typography variant="body2" align="center" sx={{ mt: 2 }}>
            Create a free account{" "}
            <Link href='/signup' underline="hover">
              Sign up
            </Link>
          </Typography>
        </Box>
      </Box>

      {/* Right Section - Image */}
      <Box
        sx={{
          flex: 1,
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
          position: "relative",
          overflow: "hidden",

        }}
      >
        <Box
          component="img"
          src="img/r1.jpg"
          alt="Signin Visual"
          sx={{
            width: "100%",
            height: "100vh",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </Box>
    </Box>
  );
}

export default Signin;